import React from "react";
import ReportConstructor from "./report-constructor";
import ReportComponentsMenuContainer from "./report-components-menu/report-components-menu-container";
import TemplateListContainer from "./templates-list/template-list-container";

class ReportConstructorController extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            reportTemplates: null,
            selectedReport: null,
            selectedReportId: null,
            selectedLanguage: this.props.selectedLanguage,
            totalElements: this.props.totalElements,
            currentPage: this.props.currentPage
        }
    }

    getTemplates = (currentPage, showedItemsCount) => {
        this.props.getReportConstructorTemplates(currentPage, showedItemsCount);
    }
//this.props.setLeftMenuComponent(<SettingsMenuContainer items={m} adminMode={true}/>, 'settingsMenu');    
    showInfrastructure = () => {
        //this.showRightMenu(this.props.topics && this.props.topics.length ? this.props.topics[0] : null)
        if(this.props.deviceType !== 'mobile') this.props.setShowRightMenu(true);
        this.showLeftMenu(this.props.topics);
        this.showRightMenu();
        this.props.setShowPanel(true, true, true, true, false, false, false, false);
    }

    getSelectedReport = (templates, selected) => {
        if(templates && templates.content && templates.content.length){
            let finded = templates.content.findIndex(k => k.id === selected);
            return templates.content[finded] ? templates.content[finded] : null;
        }
        else return null
    }

    setSelectedReportId = (reportId) => {
        this.setState({
            selectedReport: this.getSelectedReport(this.props.reportTemplates, reportId),
            selectedReportId: reportId
        })
        this.props.setIsReadOnly(true);
    }

    getReportComponent = (componentName) => {
        let res = {...this.props.reportComponents[componentName]};
        return res;
    }

    getReportParameters = (parameter) => {
        return this.props.reportParameters[parameter];
    }

    /*showCreateTemplateModal = () => {
        this.props.modalShowToggle("CreateReportTemplate", true, null,  this.props.getValue("CREATE_REPORT_TEMPLATE"), {currentPage: this.props.currentPage, showedItemsCount: this.props.showedItemsCount});
    }*/

    addParameters = (templateParameters) => {
        let reportTemplate = this.state.selectedReport;
        let parameters = reportTemplate.parameters ? reportTemplate.parameters : [];
        parameters.push(this.getReportParameters(templateParameters));
        reportTemplate.parameters = parameters;

        this.setState({
            selectedReport: reportTemplate
        })
    }

    addComponent = (componentType) => {

        let reportTemplate = {...this.state.selectedReport};
        let comps = reportTemplate.components ? reportTemplate.components : [];
        let newComponent = {...this.getReportComponent(componentType)}
        //let index = comps.length;
        //newComponent.parameters.index = index;
        comps.push(newComponent);
        reportTemplate.components = comps;

        this.setState({
            selectedReport: reportTemplate
        })
    }

    updateTemplateComponents = (index, parameters) => {
        let reportTemplate = {...this.state.selectedReport};

        let comps = reportTemplate.components ? reportTemplate.components : [];
        let component = {...comps[index]};
        component.parameters = {...parameters};
        comps[index] = component;
        this.setState({
            selectedReport: reportTemplate
        })
    }

    removeComponent = () => {
        let reportTemplate = this.state.selectedReport;

        this.setState({
            selectedReport: reportTemplate
        })
    }

    deleteReportTemplate = (id) => {
        this.props.deleteReportTemplate(id, this.props.currentPage, this.props.showedItemsCount);
    }

    showLeftMenu = (reportTemplates, leftMenuComponent) => {
        
        if(reportTemplates && reportTemplates.content){
            this.props.setShowLeftMenu(true);
            /*const reports = reportTemplates.content.map((k, i) => <Report 
                                                                        setIsReadOnly={this.setIsReadOnly} 
                                                                        isReadOnly={this.props.isReadOnly} 
                                                                        controlButtons={this.props.controlButtons} 
                                                                        getTopicName={this.getTopicName} 
                                                                        item={k} 
                                                                        getValue={this.props.getValue} 
                                                                        setSelectedReportId={this.setSelectedReportId} 
                                                                        index={i}
                                                                    />)*/
            if(leftMenuComponent.findIndex( c => c.componentName === 'reportConstructor') === -1){
                /*let createTemplateButton = <div className={s.CreateTemplateButton}>
                    <span>{this.props.getValue('LIST_OF_TEMPLATES')}</span>
                    <StandartButton title={this.props.getValue('CREATE_TEMPLATE')} icon={TopicSettingsIcon} stroke={'white'} fill={'white'} callback={this.showCreateTemplateModal}/>
                </div>*/
                this.props.setLeftMenuComponent(<div>{<TemplateListContainer deleteReportTemplate={this.deleteReportTemplate}/>}</div>, 'reportConstructor', true);
            }
                
        }
    }

    showRightMenu = () => {
        this.props.setShowRightMenu(true);
        if(this.props.rightMenuComponent.findIndex( c => c.componentName === 'ReportElements') === -1){
            this.props.setRightMenuComponent(<ReportComponentsMenuContainer addComponent={this.addComponent}/>, 'ReportElements', true);
        }
    }

    getTopicName = (topicUUID) => {
        return topicUUID;
    }

    setIsReadOnly(isReadOnly){
        this.props.setIsReadOnly(isReadOnly)
    }

    componentDidMount(){
        this.getTemplates(0, this.props.showedItemsCount);
        this.showInfrastructure();
        if(this.props.role){
            this.props.getMyTopics(this.props.role);
        }
        else{
            this.props.getMe();
        }
    }

    updateReportConstructorTemplateComponents = (id, components) => {
        this.props.updateReportConstructorTemplateComponents(id, components, this.props.currentPage, this.props.showedItemsCount);
    }

    render(){
        return(
            <ReportConstructor 
                            {...this.props} 
                            getTopicName={this.getTopicName} 
                            selectedReport={this.state.selectedReport} 
                            addNewComponent={this.addComponent} 
                            addParameters={this.addParameters} 
                            setIsReadOnly={this.setIsReadOnly} 
                            updateTemplateComponents={this.updateTemplateComponents} 
                            updateReportConstructorTemplateComponents={this.updateReportConstructorTemplateComponents} 
                            documentElementsList={this.props.documentElementsList}
                            dateFields={this.props.dateFields}
                            feedSettings={this.props.feedSettings}
                            />
        )
    }

    componentWillUnmount(){
        this.props.setRemoveLeftMenuComponent();
        this.props.setRemoveRightMenuComponent();
        this.props.setShowLeftMenu(false);
        this.props.setShowRightMenu(false);
        this.props.setShowPanel(false);
        this.props.setItemsCount(0);
        this.props.setSelectedReportTemplate(null);
    }

    shouldComponentUpdate(nextProps, nextState){
        if(nextProps.createdStatus === "SUCCESS"){
            nextProps.setCreateStatus(null);
            nextProps.setSelectedReportTemplate(null);
        }
        if(nextProps.role && (!nextProps.topics || nextProps.topics === undefined)){
            this.props.getMyTopics(nextProps.role)
            return false
        }
        if(nextProps.selectedReportTemplate !== nextState.selectedReportId){
            this.setState({
                selectedReportId: nextProps.selectedReportTemplate,
                selectedReport: this.getSelectedReport(nextProps.reportTemplates, nextProps.selectedReportTemplate),
                
            })
            nextProps.setIsReadOnly(true)
            return true;
        }
        if(nextProps.totalElements !== nextState.totalElements || nextProps.itemsCount !== nextProps.totalElements){
            this.setState({
                totalElements: nextProps.totalElements
            })
            this.props.setItemsCount(nextProps.totalElements)
        }
        if(nextProps.currentPage !== nextState.currentPage || nextProps.showedItemsCount !== nextState.showedItemsCount){
            this.getTemplates(nextProps.currentPage, nextProps.showedItemsCount);
            this.setState({
                currentPage: nextProps.currentPage,
                showedItemsCount: nextProps.showedItemsCount
            })
        }
        if(nextProps.reportTemplates && !nextState.reportTemplates || nextProps.isReportsUpdated || nextProps.selectedLanguage !== nextState.selectedLanguage){
            if(nextProps.isReportsUpdated){
                this.props.setIsReportUpdated(false);
            } 
            
            this.setState({
                reportTemplates: nextProps.reportTemplates,
                selectedLanguage: nextProps.selectedLanguage,
                selectedReport: nextState.selectedReportId ? this.getSelectedReport(nextProps.reportTemplates, nextState.selectedReportId) : null,
                currentPage: nextProps.currentPage
            })
            //this.props.setRemoveLeftMenuComponent();
            this.showLeftMenu(nextProps.reportTemplates, nextProps.leftMenuComponent);
            return true;
        }
        else return true;
    }
}

export default ReportConstructorController;